import { convertDateRangeToDates } from "@wingspanhq/fe-component-library";
import { ApiQueryListWorkLogs } from "../../../../../services/workLog";
import { UrlQuerySort } from "../../../../../shared/hooks/useUrlQuery";
import { getApiDirectionFromTable } from "../../../../../shared/utils/sorting";
import { Filter, SortField } from "./types";

export function createListRequest(
  userId: string,
  filter?: Filter,
  sort?: UrlQuerySort<SortField>
): ApiQueryListWorkLogs {
  const request: ApiQueryListWorkLogs = {
    "filter[payerId]": userId,
    "sort[updatedAt]": getApiDirectionFromTable(sort?.direction) || "desc"
  };

  if (filter?.payeeId) {
    request["filter[payeeId]"] = filter.payeeId;
  }

  if (filter?.assignmentId) {
    request["filter[payerPayeeEngagementId][=]"] = filter.assignmentId;
  }

  if (filter?.dateRange) {
    const dateRange = convertDateRangeToDates(filter.dateRange);
    if (dateRange) {
      request["filter[startDate][>]"] = dateRange.start;
      request["filter[startDate][<]"] = dateRange.end;
    }
  }

  return request;
}
